module.exports = __webpack_public_path__ + "components/tweets/static/compose-81f439df9e40f645876f747dbb262d9a.svg";